import React from "react";
import { FinancialConnection } from "@common/types/financialConnection";
import { ConnectionButtonAppearance } from "@components/financialConnection/ConnectionActionButton";
import { FixConnectionButton } from "@components/financialConnection/FixConnectionButton";
import css from "./FixFinnancialConnection.module.scss";

interface Props extends ConnectionButtonAppearance {
    connection: FinancialConnection;
    onFixed?: () => void;
    children?: React.ReactNode;
}

export const FixFinancialConnection: React.FC<Props> = ({
    children,
    ...props
}) => (
    <FixConnectionButton {...props}>
        {props.variant === "menuItem" ? (
            children
        ) : (
            <span className={css.fixConnection}>{children}</span>
        )}
    </FixConnectionButton>
);
